import type { TrialReviewStatus } from '@zeus/index'
import { $ } from '@zeus/index'
import { typedGql } from '@zeus/typedDocumentNode'
import { scalars } from '~/gql/utils/scalars'

/**
 * Parcours d'inscription qualifié en libre-service (#155). Deux mutations
 * publiques (pré-auth) côté landing, plus la revue plateforme (SuperAdmin) qui
 * décide de créer — ou non — l'espace après confirmation de l'email.
 */

/** Étape 1 : dépose une demande d'essai. Réponse constante, sans oracle. */
export const GQL_REQUEST_TRIAL = typedGql('mutation')({
  requestTrialOrganization: [
    { input: $('input', 'RequestTrialInput!') },
    { accepted: true },
  ],
})

/**
 * Étape 2 : confirme l'adresse via le jeton du mail. Ne crée plus l'espace — elle
 * fait entrer la demande en file de revue et renvoie l'état de cette revue.
 */
export const GQL_CONFIRM_TRIAL = typedGql('mutation')({
  confirmTrialOrganization: [
    { token: $('token', 'String!') },
    {
      status: true,
      email: true,
      slug: true,
      rejectionReason: true,
    },
  ],
})

/** Demandes confirmées en attente de décision (SuperAdmin). */
export const GQL_PENDING_TRIAL_REQUESTS = typedGql('query', { scalars })({
  pendingTrialRequests: {
    id: true,
    email: true,
    firstName: true,
    lastName: true,
    orgName: true,
    jobTitle: true,
    phone: true,
    createdAt: true,
    emailConfirmedAt: true,
  },
})

/** Approuve une demande : crée l'espace et envoie l'activation au demandeur. */
export const GQL_APPROVE_TRIAL = typedGql('mutation')({
  approveTrialRequest: [{ id: $('id', 'String!') }, { slug: true }],
})

/** Refuse une demande : aucune org créée, e-mail au demandeur (motif optionnel). */
export const GQL_REJECT_TRIAL = typedGql('mutation')({
  rejectTrialRequest: [{ id: $('id', 'String!'), reason: $('reason', 'String') }, true],
})

/** Forme concrète du résultat de confirmation, pour le rendu du parcours. */
export type ConfirmTrialResult = {
  status: TrialReviewStatus
  email: string
  slug?: string | null
  rejectionReason?: string | null
}

/** Une demande en attente de revue, pour l'écran SuperAdmin. */
export type TrialRequest = {
  id: string
  email: string
  firstName: string
  lastName: string
  orgName: string
  jobTitle?: string | null
  phone?: string | null
  createdAt: string
  emailConfirmedAt: string
}
